export interface ChatUser {
  uid: string;
  name: string;
  gender?: string;
  email?: string;
  phone?: string;
  avatarUrl?: string;
  isManager?: boolean;
  online?: boolean;
  lastSeen?: string;
  niNumber?: string;
  jobTitle?: string;
}

export interface ChatData {
  type: 'private' | 'group' | 'company' | 'location' | 'team';
  entityId: string;
  members: string[];
  createdAt: string;
  lastMessage: string;
  lastMessageTime: { _seconds: number };
  readOnly: boolean;
  ownerId: string;
  admins: string[];
  name: string | null;
  profiles?: ChatUser[];
  avatarUrl?: string;
  id: string;
  companyId: string;
  hasUnread: boolean;
  unreadCount: number;
  unreadCounts?: Record<string, number>;
}

export interface ChatMessage {
  senderId: string;
  senderName: string;
  senderAvatar: string;
  text: string;
  documents: ChatMessageAttachment[];
  images?: ChatMessageAttachment[];
  createdAt?: { seconds: number };
  status?: ChatMessageStatus;
  id?: string;
  edited?: boolean;
  editedAt?: { seconds: number };
  replyTo?: Partial<ChatMessage> | null;
  messageId?: string;
  forwardedFrom?: { chatId: string; messageId: string; chatName: string } | null;
  reactions?: ChatMessageReaction[];
  /** Uids that have read the message (set by markMessagesAsRead). */
  readBy?: string[];
}

export interface ChatMessageAttachment {
  type: string;
  base64Data: string;
  name: string;
  size?: number;
  url?: string;
}

export enum ChatMessageStatus {
  SENT = 'sent',
  READ = 'read',
}

export interface ChatMessageReaction {
  emoji: string;
  count: number;
  userIds?: string[];
  users?: ChatUser[];
  hasReacted?: boolean;
}
